/* Inzalo homepage v10: header state, video controls, scroll reveals, age gate */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function header() {
    var hdr = document.querySelector('[data-inz-hdr]');
    if (!hdr || hdr.getAttribute('data-overlay') !== 'true') return;
    var sentinel = document.querySelector('[data-hero-end]');
    var apply = function (solid) { hdr.classList.toggle('is-solid', solid); };
    if (!sentinel || !window.IntersectionObserver) { apply(false); return; }
    new IntersectionObserver(function (es) { apply(!es[0].isIntersecting); }, { threshold: 0 }).observe(sentinel);
  }

  function videos() {
    document.querySelectorAll('[data-vctrl]').forEach(function (btn) {
      var v = btn.parentElement ? btn.parentElement.querySelector('video') : null;
      if (!v) { btn.style.display = 'none'; return; }
      var sync = function () {
        btn.textContent = v.paused ? '▶' : 'II';
        btn.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
      };
      if (reduce) { try { v.pause(); } catch (e) {} } else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      btn.addEventListener('click', function () { if (v.paused) { v.play().catch(function () {}); } else { v.pause(); } sync(); });
      v.addEventListener('play', sync); v.addEventListener('pause', sync); sync();
    });
  }

  function reveals() {
    var els = document.querySelectorAll('.inz [data-rv]');
    if (!els.length || reduce || !window.IntersectionObserver || window.Shopify && window.Shopify.designMode) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, sib = [];
        if (el.parentElement) sib = Array.prototype.filter.call(el.parentElement.children, function (c) { return c.hasAttribute('data-rv'); });
        el.style.transitionDelay = Math.min(Math.max(sib.indexOf(el), 0), 5) * 90 + 'ms';
        el.classList.add('rv-in'); io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) { el.classList.add('rv-armed', 'rv-in'); }
      else { el.classList.add('rv-armed'); io.observe(el); }
    });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('rv-in'); }); }, 12000);
  }

  function ageGate() {
    var gate = document.querySelector('[data-inz-age]');
    if (!gate || (window.Shopify && window.Shopify.designMode)) return;
    var ok = false;
    try { ok = localStorage.getItem('inz_age_ok') === '1'; } catch (e) {}
    if (ok) return;
    gate.hidden = false; document.documentElement.style.overflow = 'hidden';
    gate.querySelector('[data-age-yes]').addEventListener('click', function () {
      try { localStorage.setItem('inz_age_ok', '1'); } catch (e) {}
      gate.hidden = true; document.documentElement.style.overflow = '';
    });
    gate.querySelector('[data-age-no]').addEventListener('click', function () {
      gate.querySelector('[data-age-msg]').hidden = false;
    });
  }

  function init() { header(); videos(); reveals(); ageGate(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
